export default __webpack_public_path__ + "c001579692a97861c7082feafb96280b.png";